<template lang="pug">
transition-group.root(
  :tag="tag"
  name="shuffle")
  slot
</template>

<script>
export default {
  name: "Shuffle",
  props: ['tag']
};
</script>

<style scoped lang="scss">
.root {
  position: relative;
  display: flex;
  flex-direction: column;
  
  &::v-deep {
    & > * {
      will-change: height;
      transform: translateZ(0);
      backface-visibility: hidden;
      perspective: 1000px;
      transition: all 350ms ease;
      left: 0;
      right: 0;
      width: 100%;
    }
    
    .shuffle-enter {
      opacity: 0;
      transform: translateY(30px);
    }
    .shuffle-leave-to {
      opacity: 0;
    }
    .shuffle-leave-active {
      position: absolute;
    }
  }
}
</style>
